import { radiusCva, shadowCva, useProvider } from "@overmap-ai/blocks"
import { cx } from "class-variance-authority"
import { type ComponentPropsWithRef, memo } from "react"
import { twMerge } from "tailwind-merge"

import { ringCva } from "../../cva"

export type BottomBarProps = ComponentPropsWithRef<"div"> & {
	position?: "fixed" | "absolute"
}

export const BottomBar = memo((props: BottomBarProps) => {
	const { children, className, position = "fixed", ...rest } = props

	const { radius } = useProvider()

	return (
		<div
			className={twMerge(
				cx(
					"w-xs bg-(--base-2) pointer-events-auto bottom-4 left-1/2 z-[1000] -translate-x-1/2 p-4",
					{ fixed: position === "fixed", absolute: position === "absolute" },
					radiusCva({ radius, maxLarge: true }),
					ringCva({ alpha: false }),
					shadowCva({ size: "md" }),
					className,
				),
			)}
			{...rest}
		>
			{children}
		</div>
	)
})
BottomBar.displayName = "BottomBar"
